import React, { useState } from 'react';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import { useSubmitContactUsMutation } from '../../redux/apiSlice';

const ContactUs: React.FC = () => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitContactUs, { isLoading, isSuccess, isError }] =
    useSubmitContactUsMutation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      await submitContactUs({
        name: fullName,
        email,
        message,
      }).unwrap();

      // Clear form on success
      setFullName('');
      setEmail('');
      setMessage('');
    } catch (err) {
      console.error('Failed to submit contact form:', err);
    }
  };

  return (
    <div className="flex flex-col justify-center items-center h-screen">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-8 rounded-3xl shadow-lg w-full max-w-2xl"
      >
        <h2 className="text-2xl font-semibold mb-6">Get in Touch</h2>

        {isSuccess && (
          <div className="mb-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded">
            Thank you! Your message has been sent successfully. Our team will
            get back to you soon.
          </div>
        )}

        {isError && (
          <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
            Failed to send message. Please try again.
          </div>
        )}

        <div className="mb-4">
          <label htmlFor="fullName" className="block text-sm font-medium mb-2">
            Full Name
          </label>
          <Input
            type="text"
            id="fullName"
            name="fullName"
            value={fullName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setFullName(e.target.value)
            }
            placeholder="Enter your full name"
            disabled={isLoading}
            required
          />
        </div>

        <div className="mb-4">
          <label htmlFor="email" className="block text-sm font-medium mb-2">
            Email Address
          </label>
          <Input
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setEmail(e.target.value)
            }
            placeholder="Enter your email"
            disabled={isLoading}
            required
          />
        </div>

        <div className="mb-4">
          <label htmlFor="message" className="block text-sm font-medium mb-2">
            Message
          </label>
          <textarea
            id="message"
            name="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Write your message here"
            className="p-2 h-[100px] w-full border border-gray-300 rounded shadow-sm bg-gray-100"
            disabled={isLoading}
            required
          />
        </div>

        <Button
          type="submit"
          className="w-full text-[24px]"
          disabled={isLoading}
        >
          {isLoading ? 'Sending...' : 'Send Message'}
        </Button>
      </form>
      <div className="mt-4 text-sm text-center">
        <a href="mailto:info@MyCodeDragon.com" className="text-gray-500">
          info@MyCodeDragon.com
        </a>
      </div>
    </div>
  );
};

export default ContactUs;
